import classnames from "classnames";
import React from "react";

// tslint:disable-next-line:no-var-requires
const style = require("./BackgroundImage.scss");

interface BackgroundImageProps {
    readonly imgSrc: string;
    readonly fallbackImgSrc: string;
    readonly isVisible: boolean;
}

class BackgroundImage extends React.Component<BackgroundImageProps> {
    constructor(props: BackgroundImageProps) {
        super(props);
        this.handleError = this.handleError.bind(this);
    }

    public render() {
        const imgSrc = this.props.imgSrc;

        const visibilityStyle = this.props.isVisible
            ? style.visible
            : style.invisible;
        const divClasses = classnames(style.screenSaverImg, visibilityStyle);

        return (
            <img
                src={imgSrc}
                className={divClasses}
                onError={this.handleError}
            />
        );
    }

    private handleError(event: any) {
        // tslint:disable-next-line:no-console
        console.log("Requested image is missing, using fallback image.");
        event.target.src = this.props.fallbackImgSrc;
    }
}

export default BackgroundImage;
